import { render, staticRenderFns } from "./AddTextModuleModal.vue?vue&type=template&id=a7254e46&"
import script from "./AddTextModuleModal.vue?vue&type=script&lang=js&"
export * from "./AddTextModuleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports